<template>
  <confirmation-dialog
    :action="handleRemove"
    :disabled="isOperationDisabled(operationDelete)"
    confirm-text="Удалить"
    confirm-btn-variant="accent"
    cancel-text="Отмена"
  >
    <template v-if="props.withActivator" #activator>
      <operation-button
        v-if="$vuetify.display.smAndUp"
        variant="link"
        size="M"
        class="text-red"
        prepend-icon-src="trash"
        prepend-icon-size="20"
        :operation="operationDelete"
      >
        Удалить
      </operation-button>
      <operation-button
        v-else
        class="text-red"
        prepend-icon-src="trash"
        prepend-icon-size="20"
        icon
        :operation="operationDelete"
      />
    </template>

    <div class="h3">
      Удаление ограничения <template v-if="props.number">#{{ props.number }}</template>
    </div>
    <div class="text-secondary mt-6">Вы уверены, что вы хотите удалить ограничение?</div>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import OperationButton from '@/core/components/buttons/OperationButton.vue';
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import { useSnackbar } from '@/core/composables/useSnackbar';
import { isOperationDisabled } from '@/core/utils/permissions';
import { OperationStatus } from '@/graphql/generated';

const props = defineProps<{
  number?: number | string;
  action: () => Promise<void>;
  withActivator?: boolean;
  operationDelete?: OperationStatus | null | undefined;
}>();

const { showSnackbar } = useSnackbar();

const handleRemove = async () => {
  await props.action();

  showSnackbar({
    type: 'success',
    title: 'Ограничение удалено',
  });
};
</script>
